import { useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import LeftMenu from '../component/admin/LeftMenu';
import Header from '../component/admin/Header';
const AdminLayout = () => {
  return (
    <>
      <Wrap>
        <LeftMenu />
        <CntArea>
          <Header />
          <CntBox>
            <Outlet />
          </CntBox>
        </CntArea>
      </Wrap>
    </>
  );
};

export default AdminLayout;

const Wrap = styled.div`
  min-width: 1024px;
  width: 100%;
  height: 100%;
  display: flex;
`;

const CntArea = styled.div`
  width: calc(100% - 240px);
  height: 100%;
  background-color: #fafafa;
`;

const CntBox = styled.div`
  width: 100%;
  min-height: calc(100vh - 80px);
`;
